import { useState } from 'react';

export default function Contact() {
  const [isDeliveryOpen, setIsDeliveryOpen] = useState(false);
  const [isFidelityOpen, setIsFidelityOpen] = useState(false);

  return (
    <section id="contact" className="py-12 px-4 bg-cream relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-rose-soft/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-rose-soft/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>

      <div className="max-w-4xl mx-auto relative">
        {/* Carte style restaurant */}
        <div className="relative">
          {/* Ombre portée */}
          <div className="absolute inset-0 bg-chocolate/20 rounded-lg transform translate-x-2 translate-y-2 blur-sm"></div>
          
          {/* Carte principale */}
          <div className="relative bg-[#FDF8F3] rounded-lg overflow-hidden" style={{ boxShadow: '0 4px 20px rgba(139, 90, 43, 0.15)' }}>
            {/* Bordure décorative extérieure */}
            <div className="absolute inset-0 border-[6px] border-chocolate/30 rounded-lg pointer-events-none"></div>
            <div className="absolute inset-[8px] border-2 border-chocolate/20 rounded pointer-events-none"></div>
            
            {/* Coins décoratifs */}
            <div className="absolute top-3 left-3 w-8 h-8 border-l-2 border-t-2 border-terracotta/60 rounded-tl"></div>
            <div className="absolute top-3 right-3 w-8 h-8 border-r-2 border-t-2 border-terracotta/60 rounded-tr"></div>
            <div className="absolute bottom-3 left-3 w-8 h-8 border-l-2 border-b-2 border-terracotta/60 rounded-bl"></div>
            <div className="absolute bottom-3 right-3 w-8 h-8 border-r-2 border-b-2 border-terracotta/60 rounded-br"></div>
            
            {/* Texture papier subtile */}
            <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.65\' numOctaves=\'3\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")' }}></div>
            
            {/* Contenu */}
            <div className="relative p-8 md:p-10">
              {/* Header avec ornements */}
              <div className="text-center mb-6">
                {/* Ornement supérieur */}
                <div className="flex items-center justify-center gap-3 mb-3">
                  <div className="flex items-center gap-1">
                    <div className="w-8 h-px bg-gradient-to-r from-transparent to-terracotta/60"></div>
                    <i className="ri-leaf-line text-terracotta/60 text-xs"></i>
                  </div>
                  <span className="text-terracotta font-semibold text-[10px] uppercase tracking-[0.2em]">
                    Pizz'ajo
                  </span>
                  <div className="flex items-center gap-1">
                    <i className="ri-leaf-line text-terracotta/60 text-xs transform scale-x-[-1]"></i>
                    <div className="w-8 h-px bg-gradient-to-l from-transparent to-terracotta/60"></div>
                  </div>
                </div>
                
                {/* Titre principal */}
                <div className="relative inline-block mb-3">
                  <h2 className="font-display text-3xl md:text-4xl font-bold text-chocolate tracking-wide">
                    Nos Informations
                  </h2>
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-24 h-0.5 bg-gradient-to-r from-transparent via-terracotta to-transparent"></div>
                </div>
                
                <p className="text-chocolate/60 text-xs max-w-xl mx-auto leading-relaxed italic">
                  Retrouvez toutes les informations pour nous contacter et nous rendre visite
                </p>
              </div>

              {/* Séparateur décoratif */}
              <div className="flex items-center justify-center gap-2 mb-6">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-chocolate/20 to-chocolate/20"></div>
                <div className="flex items-center gap-1">
                  <i className="ri-star-s-fill text-terracotta/40 text-[8px]"></i>
                  <i className="ri-map-pin-2-fill text-terracotta text-sm"></i>
                  <i className="ri-star-s-fill text-terracotta/40 text-[8px]"></i>
                </div>
                <div className="flex-1 h-px bg-gradient-to-l from-transparent via-chocolate/20 to-chocolate/20"></div>
              </div>

              {/* Programme Fidélité — case compacte cliquable */}
              <div className="mb-6 bg-gradient-to-r from-terracotta/10 via-cream/40 to-chocolate/10 rounded-xl border border-terracotta/30 overflow-hidden">
                <button
                  onClick={() => setIsFidelityOpen(!isFidelityOpen)}
                  className="w-full px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-terracotta/5 transition-colors"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-terracotta rounded-lg shrink-0">
                    <i className="ri-vip-crown-line text-base text-white"></i>
                  </div>
                  <div className="flex-1 text-left min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-display text-sm font-bold text-chocolate">Programme Fidélité</h3>
                      <span className="inline-flex items-center gap-1 text-[9px] font-bold text-terracotta bg-terracotta/10 px-2 py-0.5 rounded-full">
                        <i className="ri-refresh-line"></i> Nouveaux points
                      </span>
                    </div>
                    <p className="text-chocolate/70 text-xs leading-snug">
                      12 points à découper sur les boîtes = 1 pizza gratuite
                    </p>
                  </div>
                  <div className={`w-7 h-7 flex items-center justify-center bg-terracotta/15 rounded-lg transition-transform duration-300 shrink-0 ${isFidelityOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-terracotta text-lg"></i>
                  </div>
                </button>

                {/* Détails dépliables */}
                <div className={`overflow-hidden transition-all duration-300 ${isFidelityOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="px-4 pb-4 pt-0">
                    <div className="border-t border-terracotta/20 pt-3">
                      <p className="text-chocolate/80 text-xs leading-relaxed mb-2">
                        Suite à de nombreuses demandes, les <strong className="text-chocolate">anciens points jaunes Pizz'Ajo ne sont plus valides</strong>. Nous repartons à zéro avec de <strong className="text-terracotta">nouveaux points à découper</strong> directement sur nos boîtes à pizza !
                      </p>
                      <div className="grid sm:grid-cols-3 gap-1.5 mb-2">
                        <div className="bg-white/70 rounded-md px-2.5 py-2 border border-chocolate/10">
                          <p className="text-terracotta font-bold text-base leading-none mb-0.5">12</p>
                          <p className="text-[9px] text-chocolate/70 leading-tight">points = 1 pizza gratuite</p>
                        </div>
                        <div className="bg-white/70 rounded-md px-2.5 py-2 border border-chocolate/10">
                          <p className="text-terracotta font-bold text-base leading-none mb-0.5">36</p>
                          <p className="text-[9px] text-chocolate/70 leading-tight">points maximum</p>
                        </div>
                        <div className="bg-white/70 rounded-md px-2.5 py-2 border border-chocolate/10">
                          <i className="ri-truck-line text-terracotta text-base leading-none mb-0.5 block"></i>
                          <p className="text-[9px] text-chocolate/70 leading-tight">non pris en livraison</p>
                        </div>
                      </div>
                      <p className="text-[10px] text-chocolate/60 leading-relaxed">
                        <i className="ri-gift-line text-terracotta mr-1"></i>
                        Votre pizza gratuite est utilisable lors de votre prochaine visite.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Colonne gauche - Informations */}
                <div className="space-y-3">
                  {/* Téléphone */}
                  <div className="bg-cream/70 rounded-xl p-4 border border-chocolate/15 hover:border-terracotta/30 transition-all">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-terracotta/15 rounded-lg">
                          <i className="ri-phone-fill text-lg text-terracotta"></i>
                        </div>
                        <div>
                          <p className="text-chocolate/50 text-[10px] font-medium uppercase tracking-wider mb-0.5">Téléphone</p>
                          <p className="text-chocolate font-bold text-xs">03 60 53 27 92</p>
                        </div>
                      </div>
                      <a
                        href="tel:0360532792"
                        className="flex items-center gap-1.5 bg-terracotta text-white px-3 py-2 rounded-lg text-[11px] font-semibold hover:bg-terracotta/90 hover:shadow-lg hover:shadow-terracotta/25 transition-all cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-phone-fill text-xs"></i>
                        Appeler
                      </a>
                    </div>
                  </div>

                  {/* Horaires */}
                  <div className="bg-cream/70 rounded-xl p-4 border border-chocolate/15">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-terracotta/15 rounded-lg flex-shrink-0">
                        <i className="ri-time-line text-lg text-terracotta"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-chocolate/50 text-[10px] font-medium uppercase tracking-wider mb-2">Horaires d'ouverture</p>
                        <div className="space-y-1.5">
                          <div className="flex justify-between items-center">
                            <span className="text-chocolate/60 text-xs">Lundi</span>
                            <span className="text-chocolate font-semibold text-xs bg-rose-soft/50 px-2 py-0.5 rounded">Fermé</span>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-chocolate/60 text-xs">Mardi - Dimanche</span>
                            <span className="text-chocolate font-semibold text-xs">18h - 21h</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Disponibilités */}
                  <div className="bg-cream/70 rounded-xl p-4 border border-chocolate/15">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-terracotta/15 rounded-lg flex-shrink-0">
                        <i className="ri-calendar-check-line text-lg text-terracotta"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-chocolate/50 text-[10px] font-medium uppercase tracking-wider mb-2">Disponibilités</p>
                        <div className="space-y-1.5">
                          <div className="flex justify-between items-center">
                            <span className="text-chocolate/60 text-xs">Pizzas</span>
                            <span className="text-chocolate font-semibold text-xs">Mardi → Dimanche</span>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-chocolate/60 text-xs">Burgers</span>
                            <span className="text-chocolate font-semibold text-xs">Mardi → Jeudi</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Adresse */}
                  <div className="bg-cream/70 rounded-xl p-4 border border-chocolate/15">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-terracotta/15 rounded-lg flex-shrink-0">
                        <i className="ri-map-pin-fill text-lg text-terracotta"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-chocolate/50 text-[10px] font-medium uppercase tracking-wider mb-1">Adresse</p>
                        <p className="text-chocolate font-semibold text-sm leading-relaxed">
                          92 rue Jacques Callot<br />
                          54550 Bainville-sur-Madon
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Prise de commande */}
                  <div className="bg-terracotta/10 rounded-xl p-4 border-2 border-terracotta/25">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-terracotta rounded-lg flex-shrink-0">
                        <i className="ri-information-line text-lg text-white"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-terracotta font-bold text-sm mb-1">Prise de commande</p>
                        <p className="text-chocolate/80 text-xs leading-relaxed">
                          La prise de commande se fait <strong className="text-terracotta">uniquement sur place ou par téléphone</strong>. 
                          Utilisez les favoris pour vous souvenir de vos pizzas préférées.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Moyens de paiement */}
                  <div className="bg-cream/70 rounded-xl p-4 border border-chocolate/15">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-terracotta/15 rounded-lg flex-shrink-0">
                        <i className="ri-bank-card-line text-lg text-terracotta"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-chocolate/50 text-[10px] font-medium uppercase tracking-wider mb-2">Moyens de paiement</p>

                        {/* Acceptés */}
                        <p className="text-[9px] font-bold text-chocolate/40 uppercase tracking-wider mb-1.5">Acceptés</p>
                        <div className="flex flex-wrap gap-2 mb-3">
                          <span className="flex items-center gap-1.5 bg-terracotta/10 text-terracotta text-[11px] font-semibold px-2.5 py-1.5 rounded-full border border-terracotta/20">
                            <i className="ri-bank-card-fill text-xs"></i>
                            Carte bancaire
                          </span>
                          <span className="flex items-center gap-1.5 bg-terracotta/10 text-terracotta text-[11px] font-semibold px-2.5 py-1.5 rounded-full border border-terracotta/20">
                            <i className="ri-money-euro-circle-fill text-xs"></i>
                            Espèces
                          </span>
                        </div>

                        {/* Non acceptés */}
                        <p className="text-[9px] font-bold text-chocolate/40 uppercase tracking-wider mb-1.5">Non acceptés</p>
                        <div className="flex flex-wrap gap-2 mb-3">
                          <span className="flex items-center gap-1.5 bg-chocolate/8 text-chocolate/40 text-[11px] font-semibold px-2.5 py-1.5 rounded-full border border-chocolate/15 line-through decoration-chocolate/40">
                            <i className="ri-file-text-line text-xs"></i>
                            Chèque
                          </span>
                          <span className="flex items-center gap-1.5 bg-chocolate/8 text-chocolate/40 text-[11px] font-semibold px-2.5 py-1.5 rounded-full border border-chocolate/15 line-through decoration-chocolate/40">
                            <i className="ri-coupon-line text-xs"></i>
                            Tickets restaurant papier
                          </span>
                        </div>

                        {/* Bientôt disponible */}
                        <div className="flex items-start gap-2 bg-amber-50 border border-amber-200/70 rounded-xl px-3 py-2.5">
                          <div className="w-6 h-6 flex items-center justify-center bg-amber-100 rounded-lg shrink-0 mt-0.5">
                            <i className="ri-time-line text-amber-500 text-xs"></i>
                          </div>
                          <div>
                            <p className="text-amber-700 text-[10px] font-bold leading-tight mb-0.5">Cartes ticket restaurant</p>
                            <p className="text-amber-600 text-[10px] leading-relaxed">En cours d&apos;acquisition — bientôt disponibles</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Livraison - Accordéon */}
                  <div className="bg-gradient-to-r from-terracotta/10 to-chocolate/10 rounded-xl border border-terracotta/20 overflow-hidden">
                    <button
                      onClick={() => setIsDeliveryOpen(!isDeliveryOpen)}
                      className="w-full p-4 flex items-center justify-between cursor-pointer hover:bg-terracotta/5 transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-terracotta/20 rounded-lg">
                          <i className="ri-truck-line text-lg text-terracotta"></i>
                        </div>
                        <div className="text-left">
                          <p className="text-chocolate font-bold text-sm">Livraison disponible</p>
                          <p className="text-chocolate/50 text-[10px]">Cliquez pour voir les détails</p>
                        </div>
                      </div>
                      <div className={`w-7 h-7 flex items-center justify-center bg-terracotta/15 rounded-lg transition-transform duration-300 ${isDeliveryOpen ? 'rotate-180' : ''}`}>
                        <i className="ri-arrow-down-s-line text-terracotta text-lg"></i>
                      </div>
                    </button>
                    
                    {/* Contenu accordéon */}
                    <div className={`overflow-hidden transition-all duration-300 ${isDeliveryOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                      <div className="px-4 pb-4 pt-0">
                        <div className="border-t border-terracotta/20 pt-3 space-y-2">
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-terracotta text-xs"></i>
                            <p className="text-xs text-chocolate/70">À partir de 2 pizzas</p>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-terracotta text-xs"></i>
                            <p className="text-xs text-chocolate/70">Tarif unique : <strong className="text-chocolate">4€</strong></p>
                          </div>
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-terracotta text-xs"></i>
                            <p className="text-xs text-chocolate/70">Jeudi, vendredi et samedi uniquement</p>
                          </div>
                          
                          <div className="mt-3 pt-3 border-t border-terracotta/15">
                            <p className="text-[10px] text-chocolate font-semibold mb-1.5 flex items-center gap-1">
                              <i className="ri-map-2-line text-terracotta"></i>
                              Villages desservis :
                            </p>
                            <p className="text-[10px] text-chocolate/60 leading-relaxed">
                              Viterne, Maizières, Bainville-sur-Madon, Thélod, Xeuilley, Pulligny, Pierreville, Frolois, Pont-saint-Vincent, Sexey-aux-Forges, Neuves-Maisons, Chavigny, Chaligny, Messein
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Colonne droite - Carte */}
                <div className="bg-cream/50 rounded-xl overflow-hidden border border-chocolate/15">
                  <div className="p-3 border-b border-chocolate/10 flex items-center gap-2">
                    <i className="ri-map-pin-line text-terracotta text-sm"></i>
                    <span className="text-chocolate/70 text-xs font-medium">Nous trouver</span>
                  </div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2636.8!2d6.1667!3d48.6!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4794a3e8e8e8e8e8%3A0x8e8e8e8e8e8e8e8e!2s92%20Rue%20Jacques%20Callot%2C%2054550%20Bainville-sur-Madon!5e0!3m2!1sfr!2sfr!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0, minHeight: '320px' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localisation Pizz'Ajo - 92 rue Jacques Callot, 54550 Bainville-sur-Madon"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
